import { createFileRoute } from "@tanstack/react-router";
import ActiveRecallGuide from "@/pages/resources/ActiveRecallGuide";

export const Route = createFileRoute("/learn/active-recall")({
  head: () => ({
    meta: [
        {
            "title": "Active Recall: The Science of Effective Learning | System Atlas"
        },
        {
            "name": "description",
            "content": "Learn how active recall works and why it's the most effective study technique. Evidence-based guide with practical implementation steps."
        },
        {
            "property": "og:title",
            "content": "Active Recall: The Science of Effective Learning | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Learn how active recall works and why it's the most effective study technique. Evidence-based guide with practical implementation steps."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/active-recall"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Active Recall: The Science of Effective Learning | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Learn how active recall works and why it's the most effective study technique. Evidence-based guide with practical implementation steps."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/active-recall"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/active-recall"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/active-recall"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/active-recall"
        }
    ],
  }),
  component: ActiveRecallGuide,
});
